/**
 * Guided tour for the Observation detail view (``ObservationDetail``).
 *
 * Runs only when the user lands on a detail page *without* having seen
 * the {@link combined.ts | combined tour} (which already covers the same
 * content). Catches the direct-URL / late-creation cases.
 */
import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import {
  attachmentsStep,
  descriptionStep,
  headerActionsStep,
  metadataStep,
  peopleStep,
  safetyStep,
} from './steps';

export const OBSERVATIONS_DETAIL_TOUR_ID = 'observations.detail';

registerTour({
  id: OBSERVATIONS_DETAIL_TOUR_ID,
  name: 'Observation',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.OBSERVATIONS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Observation details',
      body:
        'Here\u2019s everything tied to this observation — context, files, ' +
        'people, and any safety details.',
    },
    headerActionsStep,
    metadataStep,
    descriptionStep,
    attachmentsStep,
    peopleStep,
    // Renders only when the observation has hazard / contributing-factor
    // data; ``safetyStep.skipIf`` drops it for routine observations.
    safetyStep,
  ],
});
